import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
/* stylelint-disable */

html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
sub,
sup,
tt,
var,
b,
u,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  vertical-align: baseline;
}
/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}
body {
  line-height: 1;
  overflow-y: scroll;
}
ol,
ul {
  list-style: none;
}
blockquote,
q {
  quotes: none;
}
a,
:visited {
  text-decoration: none;
  color: inherit;
}
blockquote:before,
blockquote:after,
q:before,
q:after {
  content: '';
  content: none;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
svg {
  cursor: pointer;
}
* {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}


html {
    font-family: Overpass;
    font-size: 10px;
    
}

body {
  box-sizing: border-box; 
}

div {
  box-sizing: border-box;
}

textarea {
  &::-webkit-scrollbar {
    width: 0.8rem;
    position: absolute;
  }

  ::-webkit-scrollbar-track {
    background: rgb(0,0,0,0.1);
  }

  ::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.5);
    border-radius: 99px;
    cursor: pointer;
    user-select: none;
  }

  &::-moz-scrollbar {
  }
  &::-ms-scrollbar {
  }
  -ms-overflow-style: none; /* IE 11 */
  scrollbar-width: none; /* Firefox 64 */
}

.container {
    max-width: 116rem;
    margin: 0 auto;
}
`;
